export default __webpack_public_path__ + "images/efe71dda05765e0e59b37221ff860cd3-nationality.jpg";